import { getChildHeadingId } from '../lib/heading-id';
import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContent } from '../types';

export type ContentSectionProps = NodeProps<{
  children: StructuredContent | StructuredContent[];
}>;

export function ContentSection({ props, ...doc }: ContentSectionProps) {
  // Legacy throws without an H2; omit the label instead because a crash is not a contract.
  const headingId = getChildHeadingId({ ...doc, props });

  return (
    <section aria-labelledby={headingId}>
      <StructuredContentRenderer doc={props.children} />
    </section>
  );
}
